module.exports =  {
  SELECTED:"SELECTED",
  HOVERED:"HOVERED",
  NORMAL:"NORMAL",
  SUPERCODED:"SUPERCODED",
  CODED:"CODED",
  UNCODED:"UNCODED"
}
